import React from "react";
import { ActivityIndicator, View } from "react-native";

function Loader() {
  return (
    <View className="flex-1 items-center bg-teachLoop-creamLight justify-center">
      <ActivityIndicator size={"large"} color={"#2C7A7B"} />
    </View>
  );
}

export default Loader;
